<template>
  <div v-if="emplacement">
    <div class="mgt-20px">
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('centreCommercialEmplacement.titleConsultation'
                , { code: emplacement.code }) }}
                <b-tag v-if="!emplacement.actif"
                      type="has-background-subMenu"
                      class="has-text-white mgl-5px">
                {{$t('centreCommercialEmplacement.archive')}}
              </b-tag>
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <b-tooltip
              size="is-large"
              :label="$t('general.button.afficher')"
              position="is-left">
              <button
                class="button mgr-2"
                :disabled="!checkPermissions(permEmplacement.lecture)"
                @click="$router.push({
                      name: 'c.gabed.emplacement-detailEmplacement',
                      params: { id: emplacement.id } })">
                <b-icon icon="file-tree" type="is-info"></b-icon>
              </button>
            </b-tooltip>
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permEmplacement.maj"
              :actions="actionSecondary"
              @click="goToModif">
                {{ $t('general.button.edit') }}
            </dropdownButton>
            <piece-jointe-button
              class="mgr-2"
              :perm="permEmplacement.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'caracteristiques'}"
            @click="activeTab = 'caracteristiques'">
            {{ $t('centreCommercialEmplacement.infoGeneral') }}
          </li>
          <li :class="{'is-active': activeTab === 'ListeDispositifs'}"
              @click="activeTab = 'ListeDispositifs'">
            {{ $t('detailEmplacement.dispoPublicitaire') }}
          </li>
          <li :class="{'is-active': activeTab === 'InfoTechnique'}"
            @click="activeTab = 'InfoTechnique'">
            {{ $t('centreCommercialEmplacement.infoTechnique') }}
          </li>
          <li :class="{'is-active': activeTab === 'ListeOtTechnique'}"
              v-if="afficherLogistique"
              @click="activeTab = 'ListeOtTechnique'">
            {{ $t('centreCommercialEmplacement.otTechnique') }}
          </li>
          <li :class="{'is-active': activeTab === 'audiences'}"
            @click="activeTab = 'audiences'">
          {{ $t('centreCommercialEmplacement.audience') }}
            </li>
          <li :class="{'is-active': activeTab === 'enseignes'}"
            @click="activeTab = 'enseignes'">
            {{ $t('centreCommercialEmplacement.enseigneMarque') }}
          </li>
        </ul>
      </div>
      <component
        :is="activeTab"
        :showPerPage="true"
        :typePatrimoine="constantes.TYPE_EMPLACEMENT"
        :ids="idsOfPatrimoine"
        :idPatrimoine="emplacement.id"
        :emplacement="emplacement"
        :entiteCommerciale="emplacement.entiteCommerciale"
        :emplacementTechniqueInformation="emplacement.emplacementTechnique"
        isCard
      />
    </div>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="emplacement"
        @no="openPopUpPrevention = false"
        @yes="archiverEmplacement"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('emplacement.archivageDesarchiver.'
        + (emplacement.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpPreventionSuppression"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="emplacement"
        @no="openPopUpPreventionSuppression = false"
        @yes="supprimerEmplacement"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('emplacement.supprimer.titre')"
        :mess-footer="$t('emplacement.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import inProgress from '@/services/general/inProgress';
import { get } from '@/api/gabed/emplacement/emplacementCentreCommercial';
import messageErreur from '@/services/general/messageErreur';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import audiences from '@/components/entiteCommerciale/c_audience';
import enseignes from '@/components/entiteCommerciale/c_enseigne';
import InfoTechnique from '@/components/emplacementTechnique/c_infoTechnique';
import { archiver, supprimer } from '@/api/gabed/emplacement';
import validationSuppression from '@/services/gabed/emplacement/validationSuppression';
import messageSucces from '@/services/general/messageSucces';
import validationEmplacement from '@/services/gabed/emplacement/validationEmplacement';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import ListeOtTechnique from '@/components/emplacementTechnique/listeOtTechnique';
import { EMPLACEMENT as TYPE_EMPLACEMENT } from '@/configuration/gabed/emplacement/emplacementConf';
import { getAll } from '@/api/gabed/dispositif';
import breadcrumb from '@/components/general/breadcrumb';
import caracteristiques from '@/components/gabed/emplacement/centreCommercial/c_caracteristiques';
import ListeDispositifs from '@/components/gabed/emplacement/l_dispositifsEmplacement';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'c_emplacementCentreCommercial',
  data() {
    return {
      emplacement: null,
      permEmplacement: EMPLACEMENT,
      activeTab: 'caracteristiques',
      errorPopUp: false,
      openPopUpPrevention: false,
      openPopUpPreventionSuppression: false,
      messagesErreurPopUp: [],
      idsOfPatrimoine: [],
      constantes: {
        TYPE_EMPLACEMENT,
      },
    };
  },
  components: {
    pieceJointeButton,
    appBreadcrumb: breadcrumb,
    caracteristiques,
    audiences,
    dropdownButton,
    enseignes,
    InfoTechnique,
    popUpPrevention,
    ListeOtTechnique,
    ListeDispositifs,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    afficherLogistique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    actionSecondary() {
      return [
        {
          label: this.$t('general.button.' + (this.emplacement.actif ? 'archiver' : 'desarchiver')),
          action: () => {
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPrevention = true;
          },
          permissionAction: EMPLACEMENT.supprimer,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => {
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPreventionSuppression = true;
          },
          permissionAction: EMPLACEMENT.supprimer,
        },
      ];
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.$route.params.id } },
          isActive: false,
        },
        { title: this.$i18n.t('detailEmplacement.types.centreCommercial'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    goToModif() {
      this.$router.push({
        name: 'm.gabed.emplacement-centreCommercialModification',
        params: { id: this.$route.params.id },
      });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async archiverEmplacement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const emplacementArchive = (await archiver(this.emplacement.id, this.emplacement.actif))
          .data.result;
        messageSucces(this.$i18n.t('emplacement.messages.success.' + (this.emplacement.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        this.emplacement.actif = emplacementArchive.actif;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEmplacement(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async supprimerEmplacement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.emplacement.id);
        messageSucces(this.$i18n.t('emplacement.messages.success.suppression'));
        this.openPopUpPreventionSuppression = false;
        this.$router.push({
          name: 'l.gabed.emplacement',
          params: { activeTab: 'emplacement' },
        });
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async getAllIds() {
      const ids = [];
      ids.push(this.emplacement.id);
      const dataBody = {
        query: {
          emplacementId: this.emplacement.id,
          societeId: this.societeActiveId,
        },
        skipCount: 0,
        maxResultCount: 200,
      };
      const allDispositif = (await getAll(dataBody)).data.result.items;
      allDispositif.forEach((dispositif) => {
        ids.push(dispositif.id);
        dispositif.materiels.forEach((materiel) => {
          ids.push(materiel.id);
          materiel.faces.forEach((face) => {
            ids.push(face.id);
          });
        });
      });
      return ids;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({
        module: 'EmplacementCentreCommercial',
      });
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key]);
      this.emplacement = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.emplacement.code }));
      await this.setAttachmentElementId({ id: this.emplacement.id });
      this.idsOfPatrimoine = await this.getAllIds();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
